import { TooltipPosition } from "@angular/material/tooltip";

export const sectionButtonData = {
    authOverride: 'authOverride',
    disabled: 'disabled',
    hide: 'hide',
    lockOnLoad: 'lockOnLoad',
    tooltip: 'tooltip',
    tooltipPosition: 'tooltipPosition',
} as const;

export type TSectionButtonData = (typeof sectionButtonData)[keyof typeof sectionButtonData];

// Door _CentralPageService gegarandeerd volledig ingevulde variant van ISectionButtonData (geen
// optionele/nullable velden meer) — dit is het type dat de btnXxxData$$-signalen exposen, zodat
// consumenten nooit zelf ?? moeten toevoegen om undefined/null af te vangen.
export type TNormalizedSectionButtonData = { [K in keyof ISectionButtonData]-?: NonNullable<ISectionButtonData[K]> };

export interface    ISectionButtonData {
    // Sectie-eigen autorisatie (bv. owner-override in notice-details): de sectie berekent
    // hide zelf al (claims/owner/lock) — de generieke claim-poort in _CentralPageService
    // moet dan niet meer bovenop verbergen.
    [sectionButtonData.authOverride]?: boolean | null;
    [sectionButtonData.disabled]?: boolean | null;
    [sectionButtonData.hide]?: boolean | null;
    [sectionButtonData.lockOnLoad]?: boolean | null;
    [sectionButtonData.tooltipPosition]?: TooltipPosition | null;
    [sectionButtonData.tooltip]?: string | null;
}

export abstract class _BaseSectionButtonData
    implements ISectionButtonData
{
    [sectionButtonData.authOverride]?: boolean | null = false;
    [sectionButtonData.disabled]?: boolean | null = true;
    [sectionButtonData.hide]?: boolean | null = false;
    [sectionButtonData.lockOnLoad]?: boolean | null = false;
    [sectionButtonData.tooltipPosition]?: TooltipPosition | null = 'above';
    [sectionButtonData.tooltip]?: string | null = '';

    protected constructor(buttonData?: ISectionButtonData) {
        if (!buttonData) return;

        this[sectionButtonData.authOverride] = buttonData?.[sectionButtonData.authOverride] ?? this[sectionButtonData.authOverride];
        this[sectionButtonData.disabled] = buttonData?.[sectionButtonData.disabled] ?? this[sectionButtonData.disabled];
        this[sectionButtonData.hide] = buttonData?.[sectionButtonData.hide] ?? this[sectionButtonData.hide];
        this[sectionButtonData.lockOnLoad] = buttonData?.[sectionButtonData.lockOnLoad] ?? this[sectionButtonData.lockOnLoad];
        this[sectionButtonData.tooltipPosition] = buttonData?.[sectionButtonData.tooltipPosition] ?? this[sectionButtonData.tooltipPosition];
        this[sectionButtonData.tooltip] = buttonData?.[sectionButtonData.tooltip] ?? this[sectionButtonData.tooltip];
    }
}
